/* eslint-disable react/prop-types */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from "react";
import { useMediaQuery } from "@mui/material";
import CrossIcon from "../../../../assets/svg/CrossIcon";
import Button from "../../../../components/common/Button";
import styles from "./SearchForm.styles";

function SearchForm({ onClose, children, heading }) {
  const isMobile = useMediaQuery("(max-width: 768px)");
  return (
    <div style={styles.container}>
      <div style={styles.header}>
        <div style={styles.title}>{heading}</div>
        <div style={styles.close} onClick={onClose}>
          <CrossIcon />
        </div>
      </div>
      <hr style={styles.divider} />
      <div
        style={{ ...styles.body, ...(isMobile && { padding: "1rem 1rem" }) }}
      >
        {children}
      </div>
      <hr style={styles.divider} />
      <div style={styles.footer}>
        <Button label="Search" type="submit" />
      </div>
    </div>
  );
}

export default SearchForm;
